// 個人資料相關翻譯

export const profile = {
    username: 'Username',
    enterUsername: 'Please enter your username',
    characters: 'characters',
    noChangesDetected: 'No changes detected',
    profileUpdatedSuccessfully: 'Profile updated successfully!',
    updateFailed: 'Update failed, please try again',
    updating: 'Updating...',
    saveChanges: 'Save Changes'
  };
